import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { useNavigate } from 'react-router-dom'
import downloadImg from '../../assets/img/download.png'
import { EMPTY_OBJECT, EVENT_LOG_TITLE, EVENT_TYPES } from '../../constants/globalConstants'
import { downloadQrcodeRequest, updatePromoCodeUsageDetails, saveBookingAfterPayment } from '../../redux/actions/paymentActions'
import Loader from '../../components/global/Loader'
import URL from '../../constants/urls'
import SixPackTicket from '../../components/downloadComponents/SixPackTicket'
import NormalTicket from '../../components/downloadComponents/NormalTicket'
import ThankYouCard from '../../components/downloadComponents/ThankYouCard'
import Header from '../../components/global/Header'
import Steps from '../../components/global/Steps'
import { dateFormatter, getPaymentCardImg } from '../../utils/helper'
import { storeEventLog } from '../../redux/actions/eventLogActions'
import getConfigDetails from '../../services/config'
import { Circles } from 'react-loader-spinner'
import { BookPaymentAnalytics } from '../../utils/GoogleAnalytics'
import queryString from 'query-string'
import useRecaptcha from '../../hooks/useRecaptcha'

function DowloadTicket(props) {
	const { dispatch, notify } = props
	const [isLoading, setIsLoading] = useState(true)
	const [paymentResponse, setPaymentResponse] = useState(EMPTY_OBJECT)
	const [paymentSession, setPaymentSession] = useState(EMPTY_OBJECT)
	const [eventDetails, setEventDetails] = useState(EMPTY_OBJECT)
	const [userEvents, setUserEvents] = useState(EMPTY_OBJECT)
	const [eventType, setEventType] = useState()
	const [paymentStatus, setPaymentStatus] = useState(false)
	const [systemError, setSystemError] = useState(false)
	const [systemErrorMessage, setSystemErrorMessage] = useState('')
	const [eventId, setEventId] = useState()
	const [cardType, setCardType] = useState()
	const [cardLastDigits, setCardLastDigits] = useState()
	const [name, setName] = useState()
	// const [coupon, setCoupon] = useState('')
	const [phone, setPhone] = useState()
	const [Reservation_id, setReservation_id] = useState()
	const [email, setEmail] = useState()
	const [promoApplied, setPromoApplied] = useState('')
	const [promoLoader, setPromoLoader] = useState(false)

	const [cardLastFour, setCardLastFour] = useState()

	const [cardExpiryYear, setCardExpiryYear] = useState()
	const [cardExpiryMonth, setCardExpiryMonth] = useState()
	const [cardPan, setCardPan] = useState()
	const [userIp, serUserIp] = useState()
	const navigate = useNavigate()
	// ===== reCAPTCHA v3 =====
	const { getToken, isReady } = useRecaptcha()
	const recaptchaTokenRef = useRef(null)
	const finalizedRef = useRef(false)
	const [readyToFinalize, setReadyToFinalize] = useState(false)

	// Generate a reCAPTCHA token before finalizing the booking.
	// Never block the ticket indefinitely if reCAPTCHA fails to load.
	useEffect(() => {
		let cancelled = false
		const prepareToken = async () => {
			if (isReady) {
				const token = await getToken('after_payment')
				if (cancelled) return
				recaptchaTokenRef.current = token
				setReadyToFinalize(true)
			}
		}
		prepareToken()
		const fallback = setTimeout(() => {
			if (!cancelled) setReadyToFinalize(true)
		}, 6000)
		return () => { cancelled = true; clearTimeout(fallback) }
	}, [isReady, getToken])
	// ===== End reCAPTCHA =====

	useEffect(() => {
		if (!readyToFinalize || finalizedRef.current) return
		finalizedRef.current = true
		window.scrollTo(0, 0)
		let queries = queryString.parse(location.search)
		setCardType(queries?.CardType)
		setCardLastDigits(queries?.CardNumberLast4)
		const phone = localStorage.getItem('phone')
		setPhone(phone)
		const reservation_id = localStorage.getItem('reservation_id')
		setReservation_id(reservation_id)
		const lastFour = localStorage.getItem('card_pan')
		setCardLastFour(lastFour)
		const name = localStorage.getItem('name')
		setName(name)
		const email = localStorage.getItem('email')
		setEmail(email)
		const event_type = localStorage.getItem('event_type')
		setEventType(event_type)
		const event_id = localStorage.getItem('event_id')
		setEventId(event_id)
		const paymentSession = JSON.parse(localStorage.getItem('paymentSession'))
		setPaymentSession(paymentSession)
		const eventDetails = JSON.parse(localStorage.getItem(EVENT_TYPES?.EVENT))
		setEventDetails(eventDetails)
		const card_pan = localStorage.getItem('card_pan')
		setCardPan(card_pan)
		const card_expiry_month = localStorage.getItem('card_date_expiry_month')
		setCardExpiryMonth(card_expiry_month)
		const card_expiry_year = localStorage.getItem('card_date_expiry_year')
		setCardExpiryYear(card_expiry_year)
		const couponFilled = localStorage.getItem('coupon') ? 'Yes' : 'No'
		const couponApplied = localStorage.getItem('couponApplied') ? localStorage.getItem('couponApplied') : 'No'
		const coupon = localStorage.getItem('coupon') ? localStorage.getItem('coupon') : 'NIL'
		// setCoupon(coupon)
		const user_ip = localStorage.getItem('user_ip')
		serUserIp(user_ip)
		const promo_Applied = localStorage.getItem('promo_applied') ? localStorage.getItem('promo_applied') : ''
		setPromoApplied(promo_Applied)
		const cardLastDigits = localStorage.getItem('card_pan') ? localStorage.getItem('card_pan') : ''
		if (!name || name == '' || !email || email == '' || !event_type || event_type == '' || !eventDetails || eventDetails == '') {
			navigate(URL.HOME)
		}
		const userEvents = localStorage.getItem('userChooseEvents')
		setUserEvents(userEvents)
		const postData = {
			facility_id: getConfigDetails.FACILITY_ID,
			name: name,
			phone: phone,
			email: email,
			// 'total' : (coupon == 'NIL' || coupon == '') ? paymentSession?.amount + paymentSession?.tax_rate : paymentSession?.amount,
			total: paymentSession?.amount,
			rate_id: event_type !== EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			event_id: event_type == EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			event_ids: event_type !== EVENT_TYPES?.EVENT && event_type !== EVENT_TYPES?.PARTY_PASS ? userEvents?.split(',') : '',
			event_category_id: eventDetails?.event_category?.id,
			arrival: event_type == EVENT_TYPES?.EVENT ? eventDetails?.event_arrival : event_type == EVENT_TYPES?.PARTY_PASS ? eventDetails?.all_event[0]?.start_time : eventDetails?.all_event[0]?.start_time,
			reference: queries?.MerchantRef,
			TxID: queries?.TxID,
			AuthorisationCode: queries?.AuthorisationCode,
			CardType: queries?.CardType,
			TokenNo: queries?.TokenNo,
			event_type: event_type,
			DSIndicator: queries?.DSIndicator,
			SCATransRef: queries?.SCATransRef,
			CardNumberLast4: cardLastDigits ? cardLastDigits : cardLastDigits
		}
		const payloadafterPayment = {
			facility_id: getConfigDetails.FACILITY_ID,
			reservation_id: Reservation_id,
			total: paymentSession?.amount,
			TokenNo: queries?.TokenNo,
			AuthorisationCode: queries?.AuthorisationCode,
			rate_id: event_type !== EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			event_id: event_type == EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			event_category_id: (event_type == EVENT_TYPES?.EVENT) ? eventDetails?.event_category_event?.event_category_id : eventDetails?.event_category_id,
			event_type: event_type,
			event_ids: event_type !== EVENT_TYPES?.EVENT && event_type !== EVENT_TYPES?.PARTY_PASS ? userEvents?.split(',') : '',
			arrival: event_type == EVENT_TYPES?.EVENT ? eventDetails?.event_arrival : event_type == EVENT_TYPES?.PARTY_PASS ? eventDetails?.all_event[0]?.start_time : eventDetails?.all_event[0]?.start_time,
			is_full_season: (event_type != EVENT_TYPES?.EVENT) ? eventDetails?.is_full_season : '',
			reference: queries?.MerchantRef ? queries?.MerchantRef : paymentSession?.reference,
			TxID: queries?.TxID,
			CardType: queries?.CardType,
			CardNumberLast4: cardLastDigits ? cardLastDigits : cardLastDigits,
			payment_status: 'success',
			recaptcha_token: recaptchaTokenRef.current
		}

		postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
			postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
			postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
			postData.couponFilled = couponFilled ? couponFilled : 'NA',
			postData.couponApplied = couponApplied ? couponApplied : 'NA',
			postData.coupon = coupon ? coupon : 'NA'
		const payload = {
			'error_message': JSON.stringify(postData),
			'event_name': EVENT_LOG_TITLE?.FINAL_PAGE,
			'user_ip': userIp ? userIp : 'NA',
			'facility_id': getConfigDetails.FACILITY_ID
		}
		dispatch(storeEventLog(payload)).then(() => {
		}).catch(() => {
		})

		if (Object.values(queries).length > 0 && queries?.AuthorisationCode !== null && queries?.AuthorisationCode !== '') {
			setPaymentStatus(true)
			postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
				postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
				postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
				postData.couponFilled = couponFilled ? couponFilled : 'NA',
				postData.couponApplied = couponApplied ? couponApplied : 'NA',
				postData.coupon = coupon ? coupon : 'NA'
			const payload = {
				'error_message': JSON.stringify(postData),
				'event_name': EVENT_LOG_TITLE?.SUCCESS,
				'user_ip': userIp ? userIp : 'NA',
				'facility_id': getConfigDetails.FACILITY_ID
			}
			dispatch(storeEventLog(payload))

			dispatch(saveBookingAfterPayment(payloadafterPayment)).then((res) => {
				if (res?.data?.message && res?.data?.message == 'Booking already done by the user.') {
					notify('error', 'Booking already done by the user.')
					navigate(URL.HOME)
				}


				setPaymentResponse(res?.data)
				setIsLoading(false)
				setPaymentStatus(true)
				if (res?.data && res?.data?.ticketech_code != '') {
					const couponCode = localStorage.getItem('coupon')
					const usagePostData = {
						'promocode': couponCode,
						'client_id': getConfigDetails?.CLIENT_ID,
						'amount': res?.data?.actual_amount,
						'transaction_id': res?.data?.anet_transaction_id,
						'email': res?.data?.user?.email,
					}
					if (couponCode != null && couponCode != '') {
						dispatch(updatePromoCodeUsageDetails(usagePostData)).then(() => {
						})
					}


					postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
						postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
						postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
						postData.couponFilled = couponFilled ? couponFilled : 'NA',
						postData.couponApplied = couponApplied ? couponApplied : 'NA',
						postData.coupon = coupon ? coupon : 'NA'
					const payload = {
						'error_message': JSON.stringify(postData),
						'event_name': EVENT_LOG_TITLE?.RESPONSE_SUCCESS,
						'user_ip': userIp ? userIp : 'NA',
						'facility_id': getConfigDetails.FACILITY_ID
					}
					dispatch(storeEventLog(payload)).then(() => {
					}).catch(() => {
					})

				} else {
					setSystemError(true)
					setSystemErrorMessage(res?.errors?.message)
					setPaymentStatus(false)
					postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
						postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
						postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
						postData.couponFilled = couponFilled ? couponFilled : 'NA',
						postData.couponApplied = couponApplied ? couponApplied : 'NA',
						postData.coupon = coupon ? coupon : 'NA',
						postData.responseMessage = res?.errors?.message
					const payload = {
						'error_message': JSON.stringify(postData),
						'event_name': EVENT_LOG_TITLE?.RESPONSE_FAILURE,
						'user_ip': userIp ? userIp : 'NA',
						'facility_id': getConfigDetails.FACILITY_ID
					}
					dispatch(storeEventLog(payload)).then(() => {
					}).catch(() => {
					})
				}
				ClickBookPaymentAnalytics(res?.data, localStorage.getItem('event_type'))
				localStorage.clear()
			}).catch((err) => {
				if (err.ticketech_code != '') {
					setIsLoading(false)
					postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
						postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
						postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
						postData.couponFilled = couponFilled ? couponFilled : 'NA',
						postData.couponApplied = couponApplied ? couponApplied : 'NA',
						postData.coupon = coupon ? coupon : 'NA',
						postData.responseMessage = err?.errors?.message

					const payload = {
						'error_message': JSON.stringify(postData),
						'event_name': EVENT_LOG_TITLE?.RESPONSE_FAILURE,
						'user_ip': userIp ? userIp : 'NA',
						'facility_id': getConfigDetails.FACILITY_ID
					}
					dispatch(storeEventLog(payload)).then(() => {
					}).catch(() => {
					})
					localStorage.clear()
				} else {
					setSystemError(true)
					setSystemErrorMessage(err?.errors?.message)
					setPaymentStatus(false)
				}


			})
		} else if (promo_Applied == 1 || promo_Applied == 2) {
			setPaymentStatus(true)
			if (promo_Applied == 1) {
				postData.promo_applied = promoApplied ? parseInt(promoApplied) : parseInt(promo_Applied)
			}

			const payload = {
				'error_message': JSON.stringify(postData),
				'event_name': EVENT_LOG_TITLE?.PROMO_PAY_SUCCESS,
				'user_ip': userIp ? userIp : 'NA',
				'facility_id': getConfigDetails.FACILITY_ID
			}
			dispatch(storeEventLog(payload))


			payloadafterPayment.facility_id = getConfigDetails.FACILITY_ID,
				payloadafterPayment.name = name,
				payloadafterPayment.phone = phone,
				payloadafterPayment.email = email,
				payloadafterPayment.total = (coupon == 'NIL' || coupon == '') ? paymentSession?.amount + paymentSession?.tax_rate : paymentSession?.amount,
				payloadafterPayment.reference = paymentSession?.reference,
				payloadafterPayment.MerchantRef = paymentSession?.reference,
				payloadafterPayment.is_booking_direct = 1

			dispatch(saveBookingAfterPayment(payloadafterPayment)).then((res) => {
				if (res?.data?.message && res?.data?.message == 'Booking already done by the user.') {
					notify('error', 'Booking already done by the user.')
					navigate(URL.HOME)
				} else {
					console.log('I am here else')

					setPaymentResponse(res.data)
					setIsLoading(false)
					setPaymentStatus(true)
					if (res?.data && res?.data?.ticketech_code) {
						const couponCode = localStorage.getItem('coupon')
						const usagePostData = {
							'promocode': couponCode,
							'client_id': getConfigDetails?.CLIENT_SECRET,
							'amount': res?.data?.actual_amount,
							'transaction_id': res?.data?.id,
							'email': res?.data?.user?.email,
						}
						if (couponCode != null && couponCode != '') {
							dispatch(updatePromoCodeUsageDetails(usagePostData)).then(() => {
							})
						}

						postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
							postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
							postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
							postData.couponFilled = couponFilled ? couponFilled : 'NA',
							postData.couponApplied = couponApplied ? couponApplied : 'NA',
							postData.coupon = coupon ? coupon : 'NA'
						const payload = {
							'error_message': JSON.stringify(postData),
							'event_name': EVENT_LOG_TITLE?.RESPONSE_SUCCESS,
							'user_ip': userIp ? userIp : 'NA',
							'facility_id': getConfigDetails.FACILITY_ID
						}
						dispatch(storeEventLog(payload)).then(() => {
						}).catch(() => {
						})
					} else {
						setSystemError(true)
						setSystemErrorMessage(res?.errors?.message)
						setPaymentStatus(false)
						postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
							postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
							postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
							postData.couponFilled = couponFilled ? couponFilled : 'NA',
							postData.couponApplied = couponApplied ? couponApplied : 'NA',
							postData.coupon = coupon ? coupon : 'NA',
							postData.responseMessage = res?.errors?.message
						const payload = {
							'error_message': JSON.stringify(postData),
							'event_name': EVENT_LOG_TITLE?.RESPONSE_FAILURE,
							'user_ip': userIp ? userIp : 'NA',
							'facility_id': getConfigDetails.FACILITY_ID
						}
						dispatch(storeEventLog(payload)).then(() => {
						}).catch(() => {
						})
					}
				}


				ClickBookPaymentAnalytics(res?.data, localStorage.getItem('event_type'))
				localStorage.clear()

			}).catch((err) => {
				setIsLoading(false)
				setSystemError(true)
				setSystemErrorMessage(err?.errors?.message)
				setPaymentStatus(false)
				postData.card_pan = cardPan ? cardPan : card_pan ? card_pan : 'NA',
					postData.card_expiry_month = cardExpiryMonth ? cardExpiryMonth : card_expiry_month ? card_expiry_month : 'NA',
					postData.card_expiry_year = cardExpiryYear ? cardExpiryYear : card_expiry_year ? card_expiry_year : 'NA',
					postData.couponFilled = couponFilled ? couponFilled : 'NA',
					postData.couponApplied = couponApplied ? couponApplied : 'NA',
					postData.coupon = coupon ? coupon : 'NA',
					postData.responseMessage = err?.errors?.message
				const payload = {
					'error_message': JSON.stringify(postData),
					'event_name': EVENT_LOG_TITLE?.RESPONSE_FAILURE,
					'user_ip': userIp ? userIp : 'NA',
					'facility_id': getConfigDetails.FACILITY_ID
				}
				dispatch(storeEventLog(payload)).then(() => {
				}).catch(() => {
				})
				localStorage.clear()

			})
		}
		else {
			setPaymentStatus(false)
			postData.card_pan = localStorage.getItem('card_pan'),
				postData.card_expiry_month = localStorage.getItem('card_date_expiry_month'),
				postData.card_expiry_year = localStorage.getItem('card_date_expiry_year')
			postData.couponFilled = localStorage.getItem('coupon') ? 'Yes' : 'No',
				postData.couponApplied = localStorage.getItem('couponApplied') ? localStorage.getItem('couponApplied') : 'No',
				postData.coupon = localStorage.getItem('coupon') ? localStorage.getItem('coupon') : 'NIL'
			const payload = {
				'error_message': JSON.stringify(postData),
				'event_name': EVENT_LOG_TITLE?.FAILURE,
				'facility_id': getConfigDetails.FACILITY_ID,
				'user_ip': localStorage.getItem('user_ip')
			}
			dispatch(storeEventLog(payload))

			if (localStorage.getItem('isSubmitted') != 1) {
				localStorage.setItem('isSubmitted', 1)
				dispatch(saveBookingAfterPayment(payloadafterPayment)).then((res) => {
					if (res?.data?.message && res?.data?.message == 'Booking already done by the user.') {
						notify('error', 'Booking already done by the user.')
						navigate(URL.HOME)
					}
					setPaymentResponse(res.data)
					setIsLoading(false)
					localStorage.setItem('isSubmitted', 1)
					//ClickBookPaymentAnalytics(res?.data,localStorage.getItem('event_type'))
				})
			}
			setIsLoading(false)
		}
	}, [readyToFinalize])
	const ClickBookPaymentAnalytics = (data, eventType) => {
		BookPaymentAnalytics(data, eventType)

	}
	const getCard = (e, ID) => {
		setPromoLoader(true)
		const pdfName = eventType == EVENT_TYPES?.EVENT ? `${eventDetails?.title}-${dateFormatter(eventDetails?.start_time, 'MM-DD-YYYY')}` : `${eventDetails?.description}-${dateFormatter(eventDetails?.all_event[0]?.start_time, 'MM-DD-YYYY')}`
		// const pdfName = eventType == EVENT_TYPES?.EVENT ? `${eventDetails?.event_category_event?.event_category?.name}-${dateFormatter(eventDetails?.start_time,'MM-DD-YYYY')}` : `${eventDetails?.description}-${dateFormatter(eventDetails?.start_date,'MM-DD-YYYY')}`
		const postData = {
			'facility_id': getConfigDetails.FACILITY_ID,
			'name': name,
			'phone': phone,
			'email': email,
			// 'total' : (coupon == 'NIL' || coupon == '') ? paymentSession?.amount + paymentSession?.tax_rate : paymentSession?.amount,
			'total': paymentSession?.amount,
			'rate_id': eventType !== EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			'event_id': eventType == EVENT_TYPES?.EVENT ? eventDetails?.id : '',
			'event_ids': eventType !== EVENT_TYPES?.EVENT && eventType !== EVENT_TYPES?.PARTY_PASS ? userEvents?.split(',') : '',
			'event_category_id': eventDetails?.event_category?.id,
			'event': eventDetails,
			'arrival': eventType == EVENT_TYPES?.EVENT ? eventDetails?.event_arrival : eventDetails?.all_event[0]?.start_time,
		}
		const payload = {
			'error_message': JSON.stringify(postData),
			'event_name': EVENT_LOG_TITLE?.DOWNLOAD_TICKET,
			'user_ip': userIp ? userIp : 'NA',
			'facility_id': getConfigDetails.FACILITY_ID
		}
		dispatch(storeEventLog(payload))


		dispatch(downloadQrcodeRequest(ID, pdfName, setPromoLoader))
	}

	return (
		isLoading ? <Loader /> :
			<div>
				<Header />

				<main>
					<Steps
						page='download'
						systemError={systemError}
						paymentStatus={paymentStatus}
					/>

					<ThankYouCard
						systemError={systemError}
						systemErrorMessage={systemErrorMessage}
						paymentStatus={paymentStatus}
						paymentResponse={paymentResponse}
						havingQR={paymentResponse?.mapco_qrcode?.length > 0 ? true : false}
					/>

					<div className="container-fluid">
						{(paymentStatus && !systemError && paymentResponse?.mapco_qrcode?.length > 0) && <div className="container mb-2">
							<div className="text-center">
								<button className="btn btn-sm d-inline-flex" disabled={promoLoader ? 'disabled' : null} onClick={(e) => getCard(e, paymentResponse?.id)} >
									<img src={downloadImg} width="18px" /> Download Ticket {' '}{promoLoader ? <span className=' ms-2'><Circles
										height="20"
										width="20"
										color="#060D63"
										ariaLabel="circles-loading"
										visible={true}
									/></span> : null}
								</button>


								{''}
								{/* <Link to={URL.HOME} className="btn btn-sm"> */}
								{' '}
								{/* <img src={printImg} width="18px" /> Print */}
								{/* </Link> */}
							</div>
						</div>}
						{(paymentStatus && !systemError && paymentResponse?.mapco_qrcode?.length > 0) ? eventType == EVENT_TYPES?.PARTY_PASS ?
							<SixPackTicket
								eventId={eventId}
								eventType={eventType}
								eventDetails={eventDetails}
								paymentResponse={paymentResponse}
							/>
							:
							<NormalTicket
								eventId={eventId}
								eventType={eventType}
								paymentResponse={paymentResponse}
							/>
							: null
						}
					</div>
					{(paymentStatus && !systemError && paymentResponse?.mapco_qrcode?.length > 0) && <div className="container">
						<div className="text-center">
							<button className="btn btn-sm d-inline-flex" disabled={promoLoader ? 'disabled' : null} onClick={(e) => getCard(e, paymentResponse?.id)} >
								<img src={downloadImg} width="18px" /> Download Ticket {' '}{promoLoader ? <span className=' ms-2'><Circles
									height="20"
									width="20"
									color="#060D63"
									ariaLabel="circles-loading"
									visible={true}
								/></span> : null}
							</button>


							{''}
							{/* <Link to={URL.HOME} className="btn btn-sm"> */}
							{' '}
							{/* <img src={printImg} width="18px" /> Print */}
							{/* </Link> */}
						</div>
					</div>}

					{!systemError && <div className="container text-start">
						<div className="row justify-content-center">
							<div className="col-12 col-md-11">
								<hr />
								<h4 className="mb-4" style={{ marginLeft: 'left' }}>Booking Information</h4>
								<div className="row">
									<div className="col-sm-3">
										<small className='fw-bold'>Email Address</small>
										<p>{paymentResponse?.user?.email ? paymentResponse?.user?.email : email}</p>
									</div>
									<div className='col-auto d-none d-sm-block border-start'></div>
									<div className="col col-sm-3">
										<small className='fw-bold'>Phone Number</small>
										<p>{paymentResponse?.user?.phone ? paymentResponse?.user?.phone : phone}</p>
									</div>
									<div className='col-auto d-none d-sm-block border-start'></div>
									<div className="col col-sm-3">
										<small className='fw-bold'>Payment Card </small>
										<p><img src={getPaymentCardImg(paymentResponse?.transaction?.card_type ? paymentResponse?.transaction?.card_type : cardType ? cardType : 'NA')} height="30px" className='me-2' /> {cardLastDigits ? `Ending with ${cardLastDigits}` : cardLastFour ? `Ending with ${cardLastFour}` : ''} </p>
									</div>
								</div>
							</div>
						</div>
					</div>}
				</main>
			</div>
	)
}
DowloadTicket.propTypes = {
	dispatch: PropTypes.func,
	data: PropTypes.object,
	notify: PropTypes.func,
}

DowloadTicket.defaulProps = {
	dispatch: noop,
	data: EMPTY_OBJECT,
	notify: noop,
}

function mapStateToProps({ peymentReducer }) {
	return {
		data: peymentReducer,
	}
}
export default connect(mapStateToProps)(DowloadTicket)
